module.exports = __webpack_public_path__ + "img/16d002-40.c36aa7d8.jpg";